// extracted by mini-css-extract-plugin
module.exports = {"container":"return-course_container__nXHJr","icon":"return-course_icon__1lU3L","title":"return-course_title__rmuOE","text":"return-course_text__lgKeS"};